import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import VueObserveVisibility from 'vue-observe-visibility';

const normalizedPath = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
const isResetRoute =
  normalizedPath === '/reset-password' || normalizedPath.endsWith('/reset-password');
const rootComponent = normalizedPath === '/integration/test-partner'
  ? require('./integration/IntegrationApp.vue').default
  : (isResetRoute ? require('./components/ResetPassword.vue').default : App);
const app = createApp(rootComponent);

app.use(store);
app.use(VueObserveVisibility);
app.mount('#app');
